import clone from "clone";
import { SelectionStats, QuestionSummary } from "../../DTOs";

// TODO
// Split into own DTO to detach from logic

export class QuestionStats
{
    public indicators:string[];
    public selections:SelectionStats;
    public commentCount:number;

    constructor(
        questionSummary:QuestionSummary
    )
    {
        this.indicators = clone(questionSummary.indicators);
        this.selections = new SelectionStats(questionSummary.selectionSummary);
        this.commentCount = questionSummary.commentCount;
    }

    static aggregateLists(q1:QuestionSummary[], q2:QuestionSummary[]):QuestionSummary[]{
        if(q1===undefined || q2===undefined || q1===null || q2 === null)
            throw new Error('invalid argument');

        if(q1.length !== q2.length)
            throw new Error('Mismatch in selectionReport lengths');

        const combined:QuestionSummary[] = [];
        for(let i=0; i<q1.length; i++){
            combined.push(QuestionStats.aggregate(q1[i], q2[i]));
        }
        return combined;
    }

    static aggregate(q1:QuestionSummary, q2:QuestionSummary):QuestionSummary
    {
        if(q1===undefined || q2===undefined || q1===null || q2 === null)
            throw new Error('invalid argument');

        if(JSON.stringify(q1.indicators.sort()) !== JSON.stringify(q2.indicators.sort()))
            throw new Error(`Indicator mismatch:${q1.indicators.join('|')} -- ${q2.indicators.join('|')}` );

        return {
            indicators: clone(q1.indicators),
            selectionSummary: SelectionStats.aggregate(q1.selectionSummary, q2.selectionSummary).data,
            commentCount: q1.commentCount + q2.commentCount
        };
    }
}